import ParentList from './ParentList'

export default ParentList
